var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestExp = function SvgRestExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    stroke: "#727582",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.334 5.333v1.334m0 0V8m0-1.333h-1.333m1.333 0h1.333m-4-3v.006M8.001 14.667a6.667 6.667 0 0 1-.194-13.331 6.464 6.464 0 0 0 6.196 9.57A6.67 6.67 0 0 1 8 14.666m2.833-11a.167.167 0 1 1-.333 0 .167.167 0 0 1 .333 0"
  })));
};
export default SvgRestExp;